import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
} from 'react';

import { withStyles } from '@material-ui/core/styles';
// import classNames from 'classnames';
import PropTypes from 'prop-types';

import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
// import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import Popover from '@material-ui/core/Popover';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import RevisionsIcon from '@material-ui/icons/Compare';
// import UsersIcon from '@material-ui/icons/Group';
import NewRevisionIcon from '@material-ui/icons/NoteAdd';
import PrintIcon from '@material-ui/icons/Print';
import UploadIcon from '@material-ui/icons/CloudUpload';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PrintSetupIcon from '@material-ui/icons/Description';
import LeftAlignIcon from '@material-ui/icons/FormatAlignLeft';
import CenterAlignIcon from '@material-ui/icons/FormatAlignCenter';
import RightAlignIcon from '@material-ui/icons/FormatAlignRight';
import BoldIcon from '@material-ui/icons/FormatBold';
import ItalicIcon from '@material-ui/icons/FormatItalic';
import StrikethroughIcon from '@material-ui/icons/StrikethroughS';
import { SuperscriptIcon } from '../Util/Icons';
import { SubscriptIcon } from '../Util/Icons';
import { MergeFieldIcon } from '../Util/Icons';
import LinkIcon from '@material-ui/icons/Link';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import BulletListIcon from '@material-ui/icons/FormatListBulleted';
import OrderedListIcon from '@material-ui/icons/FormatListNumbered';
import IndentDecreaseIcon from '@material-ui/icons/FormatIndentDecrease';
import IndentIcon from '@material-ui/icons/FormatIndentIncrease';
import ClearIcon from '@material-ui/icons/FormatClear';
import HorizontalRuleIcon from '@material-ui/icons/Remove';
// import SelectBlockIcon from '@material-ui/icons/SelectAll';
// import CodeBlockIcon from '@material-ui/icons/Code';
import InfoIcon from '@material-ui/icons/Info';
// import IncreaseIcon from '@material-ui/icons/Add';
// import DecreaseIcon from '@material-ui/icons/Remove';
import TextColorIcon from '@material-ui/icons/FormatColorText';
import HighlightColorIcon from '@material-ui/icons/FormatColorFill';

import { CompactPicker } from 'react-color';
import { Beforeunload } from 'react-beforeunload';
// import { useBeforeunload } from 'react-beforeunload';

import MultiUseDialog from './MultiUseDialog';
import AsyncSelectControl from './AsyncSelectControl';
import SelectControl from './SelectControl';
import ProgressIndicator from './ProgressIndicator';
// import NumericTextField from './NumericTextField';

// For availability, check https://github.com/KyleAMathews/typefaces/tree/master/packages
// (a subset of https://fonts.google.com/) prior to npm install
import 'typeface-alex-brush';
import 'typeface-amatic-sc';
import 'typeface-caveat';
import 'typeface-courier-prime';
import 'typeface-eb-garamond';
import 'typeface-lobster';
import 'typeface-lora';
import 'typeface-merriweather';
import 'typeface-montserrat';
import 'typeface-nunito';
import 'typeface-open-sans';
import 'typeface-oswald';
import 'typeface-pacifico';
import 'typeface-playfair-display';
import 'typeface-pt-serif';
import 'typeface-roboto';
import 'typeface-roboto-mono';
import 'typeface-spectral';

import Dropzone from 'react-dropzone';

import 'remirror/styles/all.css';
import '../Util/RemirrorOverrides.css';
import {
  AnnotationExtension,
  BoldExtension,
  BulletListExtension,
  CalloutExtension,
  CodeBlockExtension,
  ColumnsExtension,
  FontFamilyExtension,
  FontSizeExtension,
  HeadingExtension,
  // HistoryExtension,
  HorizontalRuleExtension,
  ImageExtension,
  ItalicExtension,
  LinkExtension,
  ListItemExtension,
  NodeFormattingExtension,
  OrderedListExtension,
  StrikeExtension,
  SubExtension,
  SupExtension,
  TableExtension,
  TextColorExtension,
  TextHighlightExtension,
  YjsExtension,
} from 'remirror/extensions';
import { MergeFieldPlaceholderExtension } from '../Model/Remirror/MergeFieldPlaceholderExtension';
import {
  EditorComponent,
  Remirror,
  useRemirror,
  useCommands,
  useChainedCommands,
  useHelpers,
  useActive,
  useAttrs,
  useKeymap,
  // useEditorDomRef,
  useRemirrorContext,
  // useEvent,
} from '@remirror/react';
import {
  getMarkRanges,
} from '@remirror/core';
import {
  CommandFunction,
  htmlToProsemirrorNode,
} from 'remirror';
import {
  indentList,
  dedentList,
} from '@remirror/extension-list';

import {
  chainCommands,
  newlineInCode,
  createParagraphNear,
  liftEmptyBlock,
  splitBlockKeepMarks,
} from 'prosemirror-commands';

import * as Y from 'yjs';
import { WebrtcProvider } from 'y-webrtc';
// import { ySyncPlugin, yCursorPlugin, yUndoPlugin, undo, redo } from 'y-prosemirror';
// import { prosemirrorToYDoc } from 'y-prosemirror';
import { IsMobile } from '../Util/MobileDetector';
import { convertToHtml } from 'mammoth/mammoth.browser';

import {
  GetUserValue,
} from '../Util/Properties';

const pageHeight = 400;

const _desktopToolMenuHeight = 48;
const _mobileToolMenuHeight = 48;
const styles = theme => {
  return {
    editorRoot: {
      height:"100%",
    },
    coreRoot: {
      position:"relative",
      display:"flex",
      flexDirection:"column",
      // overflow:"hidden",
      height:"100%",
      // "& .MuiOutlinedInput-input": {
      //   padding:10,
      //   paddingRight:32,
      // },
      // "& .MuiFormControl-root": {
      //   marginLeft: theme.spacing(1),
      //   marginRight: theme.spacing(1),
      // },
      "& .remirror-editor-wrapper": {
        // marginLeft:100,
        // marginRight:100,
        backgroundColor: "white",
        color:"black",
        overflowY: "auto", // This is key to exposing the editor content scrollbar
        height:`calc(100% - ${(IsMobile()) ? _mobileToolMenuHeight : _desktopToolMenuHeight}px)`,
      },
      // "& .remirror-theme .ProseMirror": {
      //   // The default value, hidden, provided by Remirror/Prosemirror, prevents the automatic page divider from working
      //   overflow:["initial", "!important"],
      // },
      // "& .remirror-editor.ProseMirror": {
      //   // The default value, scroll, provided by Remirror/Prosemirror, prevents the automatic page divider from working
      //   overflowY:"initial",
      // },
      /* this is a rough fix for the first cursor position when the first paragraph is empty */
      "& .remirror-editor.ProseMirror .ProseMirror > .ProseMirror-yjs-cursor:first-child": {
        marginTop: 16,
      },
      // This isn't good for the editor styles
      // "& .ProseMirror p:first-child, .ProseMirror h1:first-child, .ProseMirror h2:first-child, .ProseMirror h3:first-child, .ProseMirror h4:first-child, .ProseMirror h5:first-child, .ProseMirror h6:first-child": {
      //   marginTop: 16,
      // },
      /* This gives the remote user caret. The colors are automatically overwritten*/
      "& .remirror-editor.ProseMirror .ProseMirror-yjs-cursor": {
        position: "absolute",
        marginLeft: -1,
        marginRight: -1,
        marginTop: 2,
        borderLeft: "1 solid black",
        borderRight: "1 solid black",
        borderColor: "orange",
        wordBreak: "normal",
        pointerEvents: "none",
      },
      /* This renders the username above the caret */
      "& .remirror-editor.ProseMirror .ProseMirror-yjs-cursor > div": {
        position: "absolute",
        top: "1em",//-2,//"-1.05em",
        left: 2,
        fontSize: 13,
        backgroundColor: "rgba(120, 129, 0)",
        borderRadius:6,
        opacity:0.6,
        // fontFamily: "serif",
        fontStyle: "normal",
        fontWeight: "normal",
        lineHeight: "normal",
        userSelect: "none",
        color: "white",
        padding:3,
        whiteSpace: "nowrap",
      },
    },
    desktopMenuMeasure: {
      display:"flex",
      paddingLeft:theme.spacing(2),
      width:"max-content",      
      backgroundColor: theme.palette.background.default,
    },
    desktopMenu: {
      display:"flex",
      paddingLeft:theme.spacing(2),
      // flexWrap:"wrap",
      height:_desktopToolMenuHeight, // This must be fixed (even if adjusted later) to ensure editor content scrolling works as expected.
      alignItems: "center",
      backgroundColor: theme.palette.background.default,
      transition: "opacity 0.2s",
    },
    menuDivider: {
      marginLeft:theme.spacing(1),
      marginRight:theme.spacing(1),
    },
    mobileMenu: {
      display:"flex",
      alignItems: "center",
      paddingLeft:36,
      height:_mobileToolMenuHeight,
      width:"100%",
      position:"absolute",
      bottom:0,
      left:0,
      backgroundColor: theme.palette.background.default,
      overflowY:"hidden",
      overflowX:"auto",
      "&::-webkit-scrollbar": {
        height:0,
      },
    },
    editorContainer: {
      position:"relative",
      // marginTop:theme.spacing(1),
      // marginBottom:(IsMobile()) ? theme.spacing(6) : undefined,
      flexGrow:1,
      height:"100%",
      // overflow:"hidden",
    },
    editor: {
      position:"relative",
      height:"100%",
      borderRadius:4,
      // ...GetRichTextEditorStyles(theme),
      // "& .ProseMirror": {
      //   outline:"none",
      //   height:"100%",
      // }
    },
    // notch: {
    //   position:"absolute",
    //   paddingLeft:4,
    //   paddingRight:4,
    //   transition: "top 0.2s",
    // },
    // notchLabel: {
    //   fontWeight:400,
    // },
    thead: {
      fontWeight:600,
    },
    pageContent: {
      float: "left",
      width: 0.01,
      height: pageHeight,
    },
    pageDivider: {
        float: "left",
        clear: "left",
        width: "100%",
        height: 16,
        backgroundColor: theme.palette.background.default,
    },
    editorComponentContainer: {
      height: "100%",
      padding: theme.spacing(3),
      paddingRight: 0,
      paddingBottom: 0,
    },
    docXImporter: {
      height:"100%",
    },
    docxFileDropZone: {
      width:"100%",
      height:"100%",
      display:"flex",
      flexDirection:"column",
      alignItems:"center",
      justifyContent:"center",
    },
  };
};

// const initialState = {
//   "type":"doc","content":[{
//   "type":"heading","attrs":{"level":1},"content":[{
//   "type":"text","text":"Heading 1"}]},{
//   "type":"heading","attrs":{"level":2},"content":[{
//   "type":"text","text":"Heading 2"}]},{
//   "type":"heading","attrs":{"level":3},"content":[{
//   "type":"text","text":"Heading 3"}]},{
//   "type":"heading","attrs":{"level":4},"content":[{
//   "type":"text","text":"Heading 4"}]},{
//   "type":"heading","attrs":{"level":5},"content":[{
//   "type":"text","text":"Heading 5"}]},{
//   "type":"heading","attrs":{"level":6},"content":[{
//   "type":"text","text":"Heading 6"}]},{
//   "type":"paragraph","content":[{
//   "type":"text","text":"Paragraph"}]},{
//   "type":"paragraph","content":[{
//   "type":"text","marks":[{
//   "type":"link","attrs":{"href":"https://app.nucleus.one/","title":null}}],"text":"Another link here"}]},{
//   "type":"horizontalRule"},{
//   "type":"codeBlock","content":[{
//   "type":"text","text":"// Code block\nmyVar := []string{}\nmyVar = append(myVar, “newValue”)\ntest := \"123\"\nfmt.Sprintf(\"value: %v\", test)"}]},{
//   "type":"paragraph","content":[{
//   "type":"text","marks":[{
//   "type":"bold"}],"text":"Bold"}]},{
//   "type":"paragraph","content":[{
//   "type":"text","marks":[{
//   "type":"italic"}],"text":"Italic"}]},{
//   "type":"paragraph","content":[{
//   "type":"text","marks":[{
//   "type":"strike"}],"text":"Strike through"}]},{
//   "type":"paragraph","content":[{
//   "type":"text","text":"Text"},{
//   "type":"text","marks":[{
//   "type":"sup"}],"text":"Superscript"}]},{
//   "type":"paragraph","content":[{
//   "type":"text","text":"Text"},{
//   "type":"text","marks":[{
//   "type":"sub"}],"text":"Subscript"}]},{
//   "type":"orderedList","attrs":{"order":1},"content":[{
//   "type":"listItem","content":[{"type":"paragraph","content":[{
//   "type":"text","text":"Number one"}]}]},{
//   "type":"listItem","content":[{
//   "type":"paragraph","content":[{
//   "type":"text","text":"Number two"}]}]}]},{
//   "type":"bulletList","content":[{
//   "type":"listItem","content":[{
//   "type":"paragraph","content":[{
//   "type":"text","text":"Bullet one"}]}]},{
//   "type":"listItem","content":[{
//   "type":"paragraph","content":[{
//   "type":"text","text":"Bullet two"}]}]}]},{
//   "type":"paragraph","content":[{
//   "type":"image","attrs":{"src":"data:image/jpeg;base64,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","alt":"The memes people shared on social media after Google's services faced  outage | Trending News,The Indian Express","title":null}}]}
// ]};

const clearFormattingCommand: CommandFunction = ({ tr, dispatch }) => {
  const { from, to } = tr.selection;
  dispatch?.(tr.removeMark(from, to, null));

  return true;
}

const indentListCommand: CommandFunction = ({ tr, dispatch }) => {
  if (indentList(tr)) {
    dispatch?.(tr.scrollIntoView());
  }

  return true;
};

const dedentListCommand: CommandFunction = ({ tr, dispatch }) => {
  if (dedentList(tr)) {
    dispatch?.(tr.scrollIntoView());
  }

  return true;
};

const getTextColorAtSelectionCommand: CommandFunction = ({ tr, dispatch }) => {
  const [range/*, ...rest*/] = getMarkRanges(tr.curSelection, "textColor");
  if (range) {
    return range.mark.attrs.color;
  }

  return false;
};

const getTextHighlightAtSelectionCommand: CommandFunction = ({ tr, dispatch }) => {
  const [range/*, ...rest*/] = getMarkRanges(tr.curSelection, "textHighlight");
  if (range) {
    return range.mark.attrs.highlight;
  }

  return false;
};

const focusSelectionTo = (chain, to) => {
  setTimeout(() => {chain.selectText(to);chain.focus(to);chain.run();}, 250);
}

const linkActionCommand: CommandFunction = ({ tr, dispatch }) => (showTextDialog, hideDialog, attrs, chain) => {
  
  let { from, to } = tr.selection;
  showTextDialog("Link URL", null, attrs?.link()?.href || null,
    href => {
      hideDialog();
      if (!href) {
        chain.removeLink(
          { from, to },
        );
        focusSelectionTo(chain, to);
        return;
      } else {
        if (from === to) {
          chain.selectText(to);
          chain.insertText(href);
          to += href.length;
        }
        chain.updateLink(
          { href },
          { from, to },
        );
        focusSelectionTo(chain, to);
      }
    },
    () => {
      hideDialog();
      focusSelectionTo(chain, to);
    },
  );

  return true;
}

const mergeFieldActionCommand: CommandFunction = ({ tr, dispatch }) => (showFieldDialog, attrs, chain) => {
  let { from, to } = tr.selection;
  showFieldDialog(true, attrs?.mergeFieldPlaceholder(),
    field => {
      showFieldDialog(false);
      if (!field) {
        focusSelectionTo(chain, to);
        return;
      } else {
        chain.insertMergeFieldPlaceholder(field.ID, field.LabelOrName, { selection: tr.selection });
        focusSelectionTo(chain, from);
      }
    },
    () => {
      showFieldDialog(false);
      focusSelectionTo(chain, to);
    },
  );

  return true;
}

const getHooks = (showTextDialog, hideDialog) => [
  () => {
    const {
      customDispatch,
      liftListItemOutOfList,
      increaseIndent,
      decreaseIndent,
      insertHorizontalRule,
      toggleCodeBlock,
    } = useCommands();
    const chain = useChainedCommands();

    const attrs = useAttrs();

    // This is just an example of how to capture a keyup event because it's not documented properly
    // useEvent('keyup', e => {
    //   if (e.keyCode === 13) {
    //   }
    // });

    // Custom handler for ENTER key to ensure marks from prior paragraph are maintained in new paragraph
    useKeymap('Enter', ({state, view, tr, dispatch}) => {
      // console.log("Enter pressed", state, view, tr, dispatch);
      if (!liftListItemOutOfList.enabled()) {
        chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlockKeepMarks)(state, dispatch, view);
        return true;
      }
    });

    useKeymap('Tab', () => {
      // Using liftListItemOutOfList.enabled() because nothing exists right now to detect indent capability
      if (liftListItemOutOfList.enabled()) {
        customDispatch(indentListCommand);
      } else {
        increaseIndent();
      }
      return true;
    });
    useKeymap('Shift-Tab', () => {
      // Using liftListItemOutOfList.enabled() because nothing exists right now to detect dedent capability
      if (liftListItemOutOfList.enabled()) {
        customDispatch(dedentListCommand);
      } else {
        decreaseIndent();
      }
      return true;
    });
    useKeymap('Mod-Shift--', () => insertHorizontalRule());
    useKeymap('Mod-k', () => customDispatch(linkActionCommand)(showTextDialog, hideDialog, attrs, chain));
    useKeymap('Mod-Shift-c', () => customDispatch(clearFormattingCommand));
    useKeymap('Mod-Shift-`', () => toggleCodeBlock());
  },
];

const GetRemirrorParameters = funcGetYjsProvider_optional => {
  // console.log("GetRemirrorParameters");
  let extensions = [
    new AnnotationExtension(),
    new BoldExtension(),
    new BulletListExtension(),
    new CalloutExtension({ defaultType: 'warn' }),
    new CodeBlockExtension(),
    new ColumnsExtension(),
    // new ExtendedParagraphExtension(),
    new FontFamilyExtension(),
    new FontSizeExtension(),
    new HeadingExtension(),
    // new HistoryExtension(),
    new HorizontalRuleExtension(),
    new ImageExtension({ enableResizing: true }),
    new ItalicExtension(),
    new LinkExtension(),
    new ListItemExtension(),
    new MergeFieldPlaceholderExtension(),
    new NodeFormattingExtension(),
    new OrderedListExtension(),
    new StrikeExtension(),
    new SubExtension(),
    new SupExtension(),
    new TableExtension(),
    new TextColorExtension(),
    new TextHighlightExtension(),

  ];
  if (funcGetYjsProvider_optional) {
    extensions.push(new YjsExtension({ getProvider: funcGetYjsProvider_optional, disableUndo: true }));
  }

  return {
    builtin: { persistentSelectionClass: 'selection' },
    extensions: () => extensions,
    // content: '<p style=""></p>',
    // stringHandler: htmlToProsemirrorNode,
  };
}

const ToolMenu = props => {
  const {
    classes,
    theme,
    showTextDialog,
    hideDialog,
    showFieldDialog,
    showRevisions,
    showPrintSetup,
    // onReplaceStateWithDoc,
    onRequireDocXUpload,
    onCreateRevision,
    editorDisabled,
    collaborators,
    // hostWidth,
  } = props;

  const {
    focus,
    convertParagraph,
    customDispatch,
    insertHorizontalRule,
    liftListItemOutOfList,
    setFontSize,
    setFontFamily,
    setTextColor,
    removeTextColor,
    setTextHighlight,
    removeTextHighlight,
    leftAlign,
    centerAlign,
    rightAlign,
    toggleBold,
    toggleBulletList,
    toggleCodeBlock,
    toggleItalic,
    toggleHeading,
    toggleOrderedList,
    toggleStrike,
    toggleSuperscript,
    toggleSubscript,
    redo,
    undo,
  } = useCommands();
  const chain = useChainedCommands();

  const {
    getFontSizeForSelection,
  } = useHelpers();

  const active = useActive();
  const attrs = useAttrs();
  const [ ColorMenuAnchorEl, setColorMenuAnchorEl ] = useState(null);
  const [ ColorTarget, setColorTarget ] = useState(null);
  const [ MoreActionsMenuAnchorEl, setMoreActionsMenuAnchorEl ] = useState(false);
  
  const setMoreActionsMenuVisibility = visible => e => setMoreActionsMenuAnchorEl((visible) ? e.currentTarget : null);

  const handleMenuButtonClick = action => e => {
    setMoreActionsMenuVisibility(false)();
    return handleAction(e, action);
  }

  const handleAction = (e, action, options) => {
    switch (action) {
      case "leftAlign":
        leftAlign();
        focus();
        break;
      case "rightAlign":
        rightAlign();
        focus();
        break;
      case "centerAlign":
        centerAlign();
        focus();
        break;
      case "bold":
        toggleBold();
        focus();
        break;
      case "italic":
        toggleItalic();
        focus();
        break;
      case "strikethrough":
        toggleStrike();
        focus();
        break;
      case "superscript":
        toggleSuperscript();
        focus();
        break;
      case "subscript":
        toggleSubscript();
        focus();
        break;
      case "link":
        customDispatch(linkActionCommand)(showTextDialog, hideDialog, attrs, chain);
        break;
      case "mergeField":
        customDispatch(mergeFieldActionCommand)(showFieldDialog, attrs, chain);
        break;
      case "undo":
        undo();
        break;
      case "redo":
        redo();
        break;
      case "bulletList":
        toggleBulletList();
        focus();
        break;
      case "orderedList":
        toggleOrderedList();
        focus();
        break;
      case "indentList":
        customDispatch(indentListCommand);
        focus();
        break;
      case "dedentList":
        // liftListItemOutOfList();
        customDispatch(dedentListCommand);
        focus();
        break;
      case "horizontalRule":
        insertHorizontalRule();
        focus();
        break;
      case "clear":
        customDispatch(clearFormattingCommand);
        focus();
        break;
      // case "selectBlock":
      //   selectParentNode(state, dispatch);
      //   break;
      case "revisions":
        showRevisions();
        break;
      case "createRevision":
        onCreateRevision();
        break;
      case "printSetup":
        showPrintSetup();
        break;
      case "textColor":
        setColorPickerColor(customDispatch(getTextColorAtSelectionCommand) || "#000000");
        setColorMenuAnchorEl(e.currentTarget);
        setColorTarget("text");
        break;
      case "highlightColor":
        setColorPickerColor(customDispatch(getTextHighlightAtSelectionCommand) || "#ffffff");
        setColorMenuAnchorEl(e.currentTarget);
        setColorTarget("highlight");
        break;
      case "beginDocXUpload":
        onRequireDocXUpload();
        break;
      default:
        break;
    }
  }

  // const handleDocxFileDrop = files => {
  //   convertToHtml({
  //     arrayBuffer: files[0],
  //   })
  //     .then(result => {
  //       // console.log(result.value);
  //       onReplaceStateWithDoc(state => 
  //         htmlToProsemirrorNode({
  //           schema: state.schema,
  //           content: result.value,
  //         })
  //       );
  //     });
  // }

  const getDivider = key_optional => {
    return (
      <Divider key={key_optional} orientation="vertical" flexItem className={props.classes.menuDivider} />
    );
  }

  // *********
  // getHotKeyInfo() should match getCustomKeyMap() as much as possible
  // *********
  const getHotKeyInfo = () => {
    return (
      <table>
        <thead className={props.classes.thead}>
          <tr><td>Key Combo</td><td>Action</td></tr>
        </thead>
        <tbody>
          <tr><td colSpan="2"><hr /></td></tr>
          <tr><td>CTRL+SHIFT+0</td><td>Normal Text</td></tr>
          <tr><td>CTRL+SHIFT+1..6</td><td>Heading 1..6</td></tr>
          <tr><td>CTRL+SHIFT+`</td><td>Code Block</td></tr>
          <tr><td colSpan="2"><hr /></td></tr>
          <tr><td>CTRL+B</td><td>Bold</td></tr>
          <tr><td>CTRL+I</td><td>Italic</td></tr>
          <tr><td>CTRL+D</td><td>Strike-through</td></tr>
          <tr><td>CTRL+.</td><td>Superscript</td></tr>
          <tr><td>CTRL+,</td><td>Subscript</td></tr>
          <tr><td>CTRL+K</td><td>Insert Link</td></tr>
          <tr><td>CTRL+SHIFT+-</td><td>Horizontal Rule</td></tr>
          <tr><td>CTRL+SHIFT+C</td><td>Clear Formatting</td></tr>
          <tr><td colSpan="2"><hr /></td></tr>
          <tr><td>CTRL+SHIFT+8</td><td>Wrap in Bullet List</td></tr>
          <tr><td>CTRL+SHIFT+9</td><td>Wrap in Ordered List</td></tr>
          <tr><td colSpan="2"><hr /></td></tr>
          <tr><td>CTRL+Z</td><td>Undo</td></tr>
          <tr><td>CTRL+Y</td><td>Redo</td></tr>
        </tbody>
      </table>
    );
  }

  const _blockTypeListOption_paragraph = { key: "paragraph", value: "paragraph", label: "Normal Text" };
  const _blockTypeListOptions = [
    _blockTypeListOption_paragraph,
    { key: "heading1", value: "heading1", label: "Heading 1" },
    { key: "heading2", value: "heading2", label: "Heading 2" },
    { key: "heading3", value: "heading3", label: "Heading 3" },
    { key: "heading4", value: "heading4", label: "Heading 4" },
    { key: "heading5", value: "heading5", label: "Heading 5" },
    { key: "heading6", value: "heading6", label: "Heading 6" },
    { key: "codeBlock", value: "codeBlock", label: "Code Block" },
  ];

  const getCurrentBlockTypeOption = () => {
    let blockTypeOptionValue;
    if (active.heading({level:1})) {
      blockTypeOptionValue = "heading1";
    } else if (active.heading({level:2})) {
      blockTypeOptionValue = "heading2";
    } else if (active.heading({level:3})) {
      blockTypeOptionValue = "heading3";
    } else if (active.heading({level:4})) {
      blockTypeOptionValue = "heading4";
    } else if (active.heading({level:5})) {
      blockTypeOptionValue = "heading5";
    } else if (active.heading({level:6})) {
      blockTypeOptionValue = "heading6";
    } else if (active.codeBlock()) {
      blockTypeOptionValue = "codeBlock";
    } else {
      blockTypeOptionValue = _blockTypeListOption_paragraph.value;
    }
    return blockTypeOptionValue;
  }

  const handleBlockTypeChange = blockTypeListOption => {
    switch (blockTypeListOption) {
      case "heading1":
        toggleHeading({level:1});
        break;
      case "heading2":
        toggleHeading({level:2});
        break;
      case "heading3":
        toggleHeading({level:3});
        break;
      case "heading4":
        toggleHeading({level:4});
        break;
      case "heading5":
        toggleHeading({level:5});
        break;
      case "heading6":
        toggleHeading({level:6});
        break;
      case "codeBlock":
        toggleCodeBlock();
        break;
      case "paragraph":
        convertParagraph();
        break;
      default:
        break;
    }
    focus();
  }

  let blockTypeItems = [];
  if (toggleHeading.enabled()) {
    blockTypeItems.push(
      <SelectControl
        tabIndex={-1}
        key="blockType"
        id="blockType"
        // label="Block Type"
        // forceShrinkLabel
        size="small"
        style={{
          marginRight:theme.spacing(1),
        }}
        hideEmpty
        options={_blockTypeListOptions} 
        value={getCurrentBlockTypeOption()}
        onValueChange={handleBlockTypeChange}
      />
    );
  }
  if (toggleBulletList.enabled()) {
    blockTypeItems.push(
      <Tooltip key="btBullet" title="Bullet list">
        <IconButton tabIndex={-1}
          onClick={handleMenuButtonClick("bulletList")}>
          <BulletListIcon />
        </IconButton>
      </Tooltip>
    );
  }
  if (toggleOrderedList.enabled()) {
    blockTypeItems.push(
      <Tooltip key="btOrdered" title="Ordered list">
        <IconButton tabIndex={-1}
          onClick={handleMenuButtonClick("orderedList")}>
          <OrderedListIcon />
        </IconButton>
      </Tooltip>
    );
  }
  // Using liftListItemOutOfList.enabled() because nothing exists right now to detect indent capability
  if (liftListItemOutOfList.enabled()) {
    blockTypeItems.push(
      <Tooltip key="btDedentList" title="Decrease list indent">
        <IconButton tabIndex={-1}
          onClick={handleMenuButtonClick("dedentList")}>
          <IndentDecreaseIcon />
        </IconButton>
      </Tooltip>
    );
  }
  // Using liftListItemOutOfList.enabled() because nothing exists right now to detect dedent capability
  if (liftListItemOutOfList.enabled()) {
    blockTypeItems.push(
      <Tooltip key="btIndentList" title="Increase list indent">
        <IconButton tabIndex={-1}
          onClick={handleMenuButtonClick("indentList")}>
          <IndentIcon />
        </IconButton>
      </Tooltip>
    );
  }
  if (blockTypeItems.length) {
    blockTypeItems.unshift(getDivider("divBlockTypeItems"));
  }

  const _defaultFontFamily = "Roboto";
  const _fontFamilyOptions = [
    { key: "typeface-alex-brush", value: "Alex Brush", label: "Alex Brush", fontFamily: "Alex Brush", },
    { key: "typeface-amatic-sc", value: "Amatic SC", label: "Amatic SC", fontFamily: "Amatic SC" },
    { key: "typeface-caveat", value: "Caveat", label: "Caveat", fontFamily: "Caveat" },
    { key: "typeface-courier-prime", value: "Courier Prime", label: "Courier Prime", fontFamily: "Courier Prime" },
    { key: "typeface-eb-garamond", value: "EB Garamond", label: "EB Garamond", fontFamily: "EB Garamond" },
    { key: "typeface-lobster", value: "Lobster", label: "Lobster", fontFamily: "Lobster" },
    { key: "typeface-lora", value: "Lora", label: "Lora", fontFamily: "Lora" },
    { key: "typeface-merriweather", value: "Merriweather", label: "Merriweather", fontFamily: "Merriweather" },
    { key: "typeface-montserrat", value: "Montserrat", label: "Montserrat", fontFamily: "Montserrat" },
    { key: "typeface-nunito", value: "Nunito", label: "Nunito", fontFamily: "Nunito" },
    { key: "typeface-open-sans", value: "Open Sans", label: "Open Sans", fontFamily: "Open Sans" },
    { key: "typeface-oswald", value: "Oswald", label: "Oswald", fontFamily: "Oswald" },
    { key: "typeface-pacifico", value: "Pacifico", label: "Pacifico", fontFamily: "Pacifico" },
    { key: "typeface-playfair-display", value: "Playfair Display", label: "Playfair Display", fontFamily: "Playfair Display" },
    { key: "typeface-pt-serif", value: "PT Serif", label: "PT Serif", fontFamily: "PT Serif" },
    { key: "typeface-roboto", value: "Roboto", label: "Roboto", fontFamily: "Roboto" },
    { key: "typeface-roboto-mono", value: "Roboto Mono", label: "Roboto Mono", fontFamily: "Roboto Mono" },
    { key: "typeface-spectral", value: "Spectral", label: "Spectral", fontFamily: "Spectral" },
  ];

  const getCurrentFontFamily = () => {
    for (let i = 0; i < _fontFamilyOptions.length; i++) {
      const fontFamily = _fontFamilyOptions[i].value;
      if (active.fontFamily({fontFamily})) {
        return fontFamily;
      }
    }
    return _defaultFontFamily;
  }

  let fontItems = [];
  const fontSize = getFontSizeForSelection();
  const colorPopoverRef = useRef(null);
  const [ ColorPickerColor, setColorPickerColor ] = useState({});
  if (fontSize) {
    const handleFontFamilyChange = fontFamily => {
      setFontFamily(fontFamily);
      focus();
    }

    let [currentFontSize] = fontSize[0];
    if (parseInt(currentFontSize) < 4) {
      currentFontSize = "12";
    }
    fontItems.push(getDivider("divFontItems"));
    fontItems.push(
      <span key="spanFontFamily" style={{width:200, marginRight:theme.spacing(1)}}>
        <SelectControl
          tabIndex={-1}
          key="fontFamily"
          id="fontFamily"
          // label="Font Family"
          // forceShrinkLabel
          size="small"
          hideEmpty
          options={_fontFamilyOptions} 
          value={getCurrentFontFamily()}
          onValueChange={handleFontFamilyChange}
        />
      </span>
    );

    const fontSizeMin = 4;
    const fontSizeMax = 128;
    let keyDownFontSizeSelectionDate;
    const setFontSizeLocal = (size, source) => {
      // console.log("setFontSizeLocal", source);
      if (typeof size === "number" && size >= fontSizeMin && size <= fontSizeMax) {
        setFontSize(size.toString() + "pt");
        keyDownFontSizeSelectionDate = (source === "keyDown") ? new Date() : null;
      }
    }

    const handleFontSizeKeyDown = (e, inputValue) => {
      // console.log("handleFontSizeKeyDown", inputValue);
      if (e.keyCode === 13 && inputValue) {
        setFontSizeLocal(parseInt(inputValue), "keyDown");
      }
    }

    const handleFontSizePresetChange = optionOrValue => {
      // console.log("handleFontSizePresetChange", optionOrValue);
      if (optionOrValue) {
        if (optionOrValue.value) {
          const v = optionOrValue.value;
          let allowSet = true;
          if (keyDownFontSizeSelectionDate) {
            let d = new Date(keyDownFontSizeSelectionDate);
            d.setMilliseconds(d.getMilliseconds() + 100);
            if (d > new Date()) {
              allowSet = false;
            }
          } 
          if (allowSet) {
            setFontSizeLocal(parseInt(v), "preset");
          }
        } else if (typeof optionOrValue === "string") {
          setFontSizeLocal(parseInt(optionOrValue), "select");
        }
      }
    }

    const fontSizePresets = [8,9,10,11,12,14,16,18,20,24,32,48,60,72,96,128];
    const fontSizeOptions = fontSizePresets.map(o => { return {label:o.toString(), value:o.toString()}; });
    if (!IsMobile()) {
      fontItems.push(
        // <Tooltip key="btDecreaseFont" title="Decrease font size">
        //   <IconButton tabIndex={-1} size="small"
        //     onClick={handleMenuButtonClick("decreaseFontSize")}>
        //     <DecreaseIcon />
        //   </IconButton>
        // </Tooltip>,
          <AsyncSelectControl
            key="fontSize"
            floatingOptions
            onGetOptionsFilterPromise={() => Promise.resolve(fontSizeOptions)}
            listValues={{label:currentFontSize.toString(), value: currentFontSize.toString()}}
            onValueChange={handleFontSizePresetChange}
            onKeyDown={handleFontSizeKeyDown}
            notClearable
            compact
          />,

        //  <Tooltip key="btIncreaseFont" title="Increase font size">
        //   <IconButton tabIndex={-1} size="small"
        //     onClick={handleMenuButtonClick("increaseFontSize")}>
        //     <IncreaseIcon />
        //   </IconButton>
        // </Tooltip>,
      );
    }
    if (IsMobile()) {
      fontItems.push(
        <SelectControl
          key="fontSize"
          id="fontSize"
          size="small"
          // style={{
          //   marginRight:theme.spacing(1),
          // }}
          hideEmpty
          options={fontSizeOptions} 
          value={currentFontSize}
          onValueChange={handleFontSizePresetChange}
        />
      );
    }

    const handleColorChange = (color, e) => {
      setColorPickerColor(color);
    }

    const handleColorChangeComplete = (color, e) => {
      setColorPickerColor(color);
      // console.log(color, e);
      switch (ColorTarget) {
        case "text":
          if (color.hex === "#000000") {
            removeTextColor();
          } else {
            setTextColor(color.hex);
          }
          break;
        case "highlight":
          if (color.hex === "#ffffff") {
            removeTextHighlight();
          } else {
            setTextHighlight(color.hex);
          }
          break;
        default:
          break;
      }
    }

    const handleColorPopoverBlur = e => {
      if (!colorPopoverRef
        || !colorPopoverRef.current.contains(document.activeElement)) {
        setColorMenuAnchorEl(null);
      }
    }

    fontItems.push(
      <Tooltip key="btTextColor" title="Text color">
        <IconButton tabIndex={-1}
          style={{marginLeft:theme.spacing(1)}}
          onClick={handleMenuButtonClick("textColor")}>
          <TextColorIcon />
        </IconButton>
      </Tooltip>,
      <Tooltip key="btHighlightColor" title="Highlight color">
        <IconButton tabIndex={-1}
          onClick={handleMenuButtonClick("highlightColor")}>
          <HighlightColorIcon />
        </IconButton>
      </Tooltip>,
      <Popover
        key="colorMenu"
        anchorEl={ColorMenuAnchorEl}
        // keepMounted
        open={Boolean(ColorMenuAnchorEl)}
        onBlur={e => setTimeout(() => handleColorPopoverBlur(e), 1)}
        anchorOrigin={{
          vertical:'bottom',
          horizontal:'center',
        }}
        transformOrigin={{
          vertical:'top',
          horizontal:'center',
        }}
        ref={colorPopoverRef}
      >
        <CompactPicker
          color={ColorPickerColor}
          onChange={handleColorChange}
          onChangeComplete={handleColorChangeComplete}
        />
      </Popover>
    );
  }

  const printButton = (
    <Tooltip title="Print" key="mPrint">
      <IconButton tabIndex={-1}
        onClick={() => window.print()}>
        <PrintIcon />
      </IconButton>
    </Tooltip>
  );
  const moreActionsMenu = (
    <React.Fragment key="mMore">
    <IconButton
      aria-label="More actions menu"
      aria-controls="moreActions-menu"
      aria-haspopup="true"
      onClick={setMoreActionsMenuVisibility(true)}
    >
      <MoreVertIcon />
    </IconButton>
    <Menu
      id="moreActions-menu"
      anchorEl={MoreActionsMenuAnchorEl}
      keepMounted
      open={Boolean(MoreActionsMenuAnchorEl)}
      onClose={setMoreActionsMenuVisibility(false)}
    >
      <MenuItem onClick={handleMenuButtonClick("printSetup")}>
        <ListItemIcon><PrintSetupIcon /></ListItemIcon>
        Print setup
      </MenuItem>
      <MenuItem onClick={handleMenuButtonClick("revisions")}>
        <ListItemIcon><RevisionsIcon /></ListItemIcon>
        Revisions
      </MenuItem>
      <MenuItem onClick={handleMenuButtonClick("createRevision")}>
        <ListItemIcon><NewRevisionIcon /></ListItemIcon>
        Save to new revision
      </MenuItem>
      <MenuItem onClick={handleMenuButtonClick("beginDocXUpload")}>
        <ListItemIcon><UploadIcon /></ListItemIcon>
        Import from DOCX
      </MenuItem>
    </Menu>
    </React.Fragment>
  )
  const leftAlignButton = (
    <Tooltip title="Left align" key="mLeftAlign">
      <span>
      <IconButton tabIndex={-1}
        disabled={!leftAlign.enabled()}
        onClick={handleMenuButtonClick("leftAlign")}>
        <LeftAlignIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const rightAlignButton = (
    <Tooltip title="Right align" key="mRightAlign">
      <span>
      <IconButton tabIndex={-1}
        disabled={!rightAlign.enabled()}
        onClick={handleMenuButtonClick("rightAlign")}>
        <RightAlignIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const centerAlignButton = (
    <Tooltip title="Center align" key="mCenterAlign">
      <span>
      <IconButton tabIndex={-1}
        disabled={!centerAlign.enabled()}
        onClick={handleMenuButtonClick("centerAlign")}>
        <CenterAlignIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const boldButton = (
    <Tooltip title="Bold" key="mBold">
      <span>
      <IconButton tabIndex={-1}
        disabled={!toggleBold.enabled()}
        onClick={handleMenuButtonClick("bold")}>
        <BoldIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const italicButton = (
    <Tooltip title="Italic" key="mItalic">
      <span>
      <IconButton tabIndex={-1}
        disabled={!toggleItalic.enabled()}
        onClick={handleMenuButtonClick("italic")}>
        <ItalicIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const strikeButton = (
    <Tooltip title="Strikethrough" key="mStrike">
      <span>
      <IconButton tabIndex={-1}
        disabled={!toggleStrike.enabled()}
        onClick={handleMenuButtonClick("strikethrough")}>
        <StrikethroughIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const superscriptButton = (
    <Tooltip title="Superscript" key="mSuper">
      <span>
      <IconButton tabIndex={-1}
        disabled={!toggleSuperscript.enabled()}
        onClick={handleMenuButtonClick("superscript")}>
        <SuperscriptIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const subscriptButton = (
    <Tooltip title="Subscript" key="mSub">
      <span>
      <IconButton tabIndex={-1}
        disabled={!toggleSubscript.enabled()}
        onClick={handleMenuButtonClick("subscript")}>
        <SubscriptIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const linkButton = (
    <Tooltip title="Link" key="mLink">
      <IconButton tabIndex={-1}
        onClick={handleMenuButtonClick("link")}>
        <LinkIcon />
      </IconButton>
    </Tooltip>
  );
  const fieldValuePlaceholderButton = (
    <Tooltip title="Insert merge field" key="mMergeField">
      <IconButton tabIndex={-1}
        onClick={handleMenuButtonClick("mergeField")}>
        <MergeFieldIcon />
      </IconButton>
    </Tooltip>
  );
  const ruleButton = (
    <Tooltip title="Horizontal rule" key="mRule">
      <span>
      <IconButton tabIndex={-1}
        disabled={!insertHorizontalRule.enabled()}
        onClick={handleMenuButtonClick("horizontalRule")}>
        <HorizontalRuleIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const clearButton = (
    <Tooltip title="Clear formatting" key="mClear">
      <IconButton tabIndex={-1}
        onClick={handleMenuButtonClick("clear")}>
        <ClearIcon />
      </IconButton>
    </Tooltip>
  );
  const undoButton = (
    <Tooltip title="Undo" key="mUndo">
      <span>
      <IconButton tabIndex={-1}
        // disabled={!undoDepth(RichTextEditorState)}
        onClick={handleMenuButtonClick("undo")}>
        <UndoIcon />
      </IconButton>
      </span>
    </Tooltip>
  );
  const redoButton = (
    <Tooltip title="Redo" key="mRedo">
      <span>
      <IconButton tabIndex={-1}
        // disabled={!redoDepth(RichTextEditorState)}
        onClick={handleMenuButtonClick("redo")}>
        <RedoIcon />
      </IconButton>
      </span>
    </Tooltip>
  );

  const hotKeyInfo = (
    <Tooltip key="hotKeyInfo" title={getHotKeyInfo()}>
      <InfoIcon style={{color:theme.palette.text.secondary,margin:theme.spacing(1)}} />
    </Tooltip>
  );

  let collabItems = [];
  if (collaborators && collaborators.length) {
    let uniqueCollaboratorEmails = [];
    let collaboratorAvatars = [];
    collaborators.forEach(c => {
      if (uniqueCollaboratorEmails.filter(e => e === c.email).length) {
        return;
      }
      uniqueCollaboratorEmails.push(c.email);
      collaboratorAvatars.push(
        <span key={c.email} style={{marginRight:-8}}>
          {GetUserValue(c.email, c.name, "", true)}
        </span>
      );
    });
    collabItems.push(
      getDivider("dEnd2"),
      collaboratorAvatars,
    );
  }

  const desktopMenuItems = (editorDisabled)
    ? [
      printButton,
    ]
    : [
      moreActionsMenu,
      printButton,
      (<React.Fragment key="mBlock">{blockTypeItems}</React.Fragment>),
      (<React.Fragment key="mFont">{fontItems}</React.Fragment>),
      getDivider("dAlignment"),
      leftAlignButton,
      centerAlignButton,
      rightAlignButton,
      getDivider("dMarks"),
      boldButton,
      italicButton,
      strikeButton,
      superscriptButton,
      subscriptButton,
      linkButton,
      fieldValuePlaceholderButton,
      ruleButton,
      clearButton,
      getDivider("dHistory"),
      undoButton,
      redoButton,
      getDivider("dEnd1"),
      hotKeyInfo,
      (<React.Fragment key="mCollab">{collabItems}</React.Fragment>),
    ];

  // const desktopMenuMeasureRef = useRef(null);
  // const desktopMenuMeasure = (
  //   <div className={classes.desktopMenuMeasure} ref={desktopMenuMeasureRef}>
  //     {desktopMenuItems}
  //   </div>
  // );

  let desktopMenuHeight = _desktopToolMenuHeight;
  // // console.log(hostWidth, desktopMenuMeasureRef && desktopMenuMeasureRef.current && desktopMenuMeasureRef.current.clientWidth)
  // if (desktopMenuMeasureRef && desktopMenuMeasureRef.current
  //   && desktopMenuMeasureRef.current.scrollWidth > hostWidth) {
  //   desktopMenuHeight = Math.ceil(desktopMenuMeasureRef.current.scrollWidth / hostWidth)
  //     * _desktopToolMenuHeight;
  // }
  const desktopMenu = (
    <div className={classes.desktopMenu}
      style={{
        height: desktopMenuHeight,
      }}
    >
      {desktopMenuItems}
    </div>
  );

  const mobileMenu = (!editorDisabled) ? (
    <div className={classes.mobileMenu}>
      {boldButton}
      {italicButton}
      {strikeButton}
      {superscriptButton}
      {subscriptButton}
      {linkButton}
      {ruleButton}
      {clearButton}
      {blockTypeItems}
      {fontItems}
      {getDivider()}
      {leftAlignButton}
      {centerAlignButton}
      {rightAlignButton}
      {getDivider()}
      {undoButton}
      {redoButton}
    </div>
  ) : null;
 
  return (IsMobile()) ? mobileMenu : desktopMenu;
}

// const PageDividersComponent = withStyles(styles, {withTheme: true})((props) => {
//   const {
//     classes,
//   } = props;
//   useRemirrorContext({ autoUpdate: true });
//   const ref = useEditorDomRef();
//   const [ pageDividers, setPageDividers ] = useState([]);
  
//   useEffect(() => {
//     console.log("PageDividersComponent useEffect");
//     let newPageDividers = [];
//     for (let i = 0; i < Math.ceil(ref.current.clientHeight / pageHeight); i++) {
//       newPageDividers.push(
//         <div key={`k_pc_${i}`} className={classes.pageContent} />,
//         <div key={`k_pd_${i}`}className={classes.pageDivider} />
//       );  
//     }
//     setPageDividers(newPageDividers);
//   }, [ref.current.clientHeight]);

//   return pageDividers;
// })

const PersistenceComponent = props => {
  const {
    yDoc,
    initialRemirrorHtml,
    onClearInitialRemirrorHtml,
    onEditorLoaded,
    onSetPrintContent,
    onSetOtherAppBarContent,
    onLoadDocumentContent,
    onYjsUpdate,
    onHtmlUpdate,
    onRemirrorStateUpdate,
    onSetReady,
    onSetYjsAwarenessField,
    createRevisionTimestamp,
    theme,
  } = props;


  const {
    manager,
    setContent,
    // commands,
    helpers,
    // ...rest
  } = useRemirrorContext();

  const [ isUploadingYjs, setIsUploadingYjs ] = useState(false);
  const [ isUploadingHtml, setIsUploadingHtml ] = useState(false);
  const [ isUploadingRemirrorState, setIsUploadingRemirrorState ] = useState(false);

  useEffect(() => {
    if (isUploadingYjs || isUploadingHtml || isUploadingRemirrorState) {
      onSetOtherAppBarContent(
        <div style={{marginLeft:32,display:"flex",opacity:0.5}}>
          <CircularProgress size={16} style={{color:"white"}} />
          <Typography variant="caption" style={{marginLeft:theme.spacing(1)}}>
            Saving...
          </Typography>
        </div>
      );
    } else {
      onSetOtherAppBarContent(null);
    }
  }, [ isUploadingYjs, isUploadingHtml, isUploadingRemirrorState, onSetOtherAppBarContent, theme ]);

  const getHtml = () => {
    const state = manager.getState();
    return helpers.getHTML(state);
  }

  const getRemirrorState = () => {
    const state = manager.getState();
    return JSON.stringify(state.doc);
  }

  // const setCollaboratorReloadRequest = () => {
  //   onSetYjsAwarenessField("reload", new Date());
  // }

  const setCollaboratorDestroyAndReloadRequest = () => {
    onSetYjsAwarenessField("docDestroyAndRequestReload", new Date());
  }

  useEffect(() => {
    onEditorLoaded(getHtml, setCollaboratorDestroyAndReloadRequest);
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleHtmlChanged = signedUrl => {
    if (!signedUrl) {
      return;
    }
    // console.log("handleHtmlChanged", signedUrl);

    const stateAsHtml = getHtml();
    // console.log("to onHtmlUpdate");
    setIsUploadingHtml(true);
    return onHtmlUpdate(signedUrl, stateAsHtml)
      .finally(() => {
        // console.log("html persist complete");
        setIsUploadingHtml(false);
      });
  }

  const handleProsemirrorStateChanged = signedUrl => {
    if (!signedUrl) {
      return;
    }
    // console.log("handleProsemirrorStateChanged", signedUrl);

    const state = getRemirrorState();
    // console.log("to onRemirrorStateUpdate", manager.getState());
    setIsUploadingRemirrorState(true);
    return onRemirrorStateUpdate(signedUrl, state)
      .finally(() => {
        // console.log("remirror state persist complete");
        setIsUploadingRemirrorState(false);
      });
  }

  let incrementRevision = false;
  const persistYjs = (updateBinary_optional, forceIncrementRevision) => {
    // console.log("persistYjs", incrementRevision);

    const onReservationObtained = reservation => {
      // console.log("to handleHtmlChanged", reservation.SignedUrl2);
      handleHtmlChanged(reservation.SignedUrl2);
      // console.log("to handleProsemirrorStateChanged", reservation.SignedUrl3);
      handleProsemirrorStateChanged(reservation.SignedUrl3)
    }

    if (!updateBinary_optional) {
      updateBinary_optional = Y.encodeStateAsUpdate(yDoc);  
    }
    // console.log(updateBinary_optional);
    setIsUploadingYjs(true);
    onYjsUpdate(updateBinary_optional, incrementRevision || forceIncrementRevision, onReservationObtained)
      .finally(() => {
        incrementRevision = false;
        setIsUploadingYjs(false);
        // console.log("onYjsUpdate complete");
      });
  }

  const initYjsPersistence = () => {
    const yXmlFragment = yDoc.getXmlFragment('prosemirror');
    yXmlFragment.observeDeep(
      (events, transaction) => {
        // console.log("yXmlFragment", yXmlFragment);
        // console.log("yXmlFragment.observeDeep()");
        if (transaction.local) {
          persistYjs();
        } else {
          setTimeout(() => onSetPrintContent(getHtml()), 1);
        }
      },
    );
  }

  const getDocumentFromPersistence = () => {
    // console.log("getDocumentFromPersistence to onLoadDocumentContent");
    return onLoadDocumentContent()
      .then(resp => {
        // console.log("document content", resp);
        if (resp && resp.data && resp.data.byteLength) {
          const respArray = new Uint8Array(resp.data);
          if (resp.headers && resp.headers["content-type"] === "prosemirror-state") {
            var dec = new TextDecoder("utf-8");
            const state = JSON.parse(dec.decode(respArray));
            // manager.view.updateState(manager.createState({ content: state }));
            setContent(state);
          } else {
            Y.applyUpdate(yDoc, respArray);
          }
          const html = getHtml();
          // console.log(html);
          onSetPrintContent(html);
        }
      });
  }

  useEffect(() => {
    if (createRevisionTimestamp) {
      persistYjs(null, true);
    }
  }, [ createRevisionTimestamp ]); // eslint-disable-line react-hooks/exhaustive-deps

  const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));
  const handleInitialRemirrorHtml = async onSetIncrementRevision => {
    // console.log("initialRemirrorHtml", initialRemirrorHtml);

    incrementRevision = true;

    // Issue a request for collaborators to stop collaborating and reload
    setCollaboratorDestroyAndReloadRequest();
    
    await sleep(3000);
    
    const state = manager.getState();
    const doc = htmlToProsemirrorNode({
      schema: state.schema,
      content: initialRemirrorHtml,
    });
    onClearInitialRemirrorHtml();

    setContent(doc);

    onSetReady(true);
  }

  const [ initialized, setInitialized ] = useState(false);
  if (!initialized) {
    setInitialized(true);
    // console.log("initializing");

    // Initialize the YJS persistence function
    initYjsPersistence();

    // For normal load-from-persistence
    if (!initialRemirrorHtml) {
      // console.log("to getDocumentFromPersistence()");
      getDocumentFromPersistence()
        .finally(() => {
          onSetReady(true);
        });
    }
    
    // For importing from DOCX
    if (initialRemirrorHtml) {
      handleInitialRemirrorHtml();
    }
  }

  // useEffect(() => {
  //   console.log("isUploadingYjs", isUploadingYjs);
  // }, [isUploadingYjs]);
  // useEffect(() => {
  //   console.log("isUploadingHtml", isUploadingHtml);
  // }, [isUploadingHtml]);
  // useEffect(() => {
  //   console.log("isUploadingRemirrorState", isUploadingRemirrorState);
  // }, [isUploadingRemirrorState]);

  return (
    <Beforeunload onBeforeunload={e => {
      if (isUploadingYjs || isUploadingHtml || isUploadingRemirrorState) {
        e.preventDefault();
      }
    }} />
  );
}

const Core = withStyles(styles, {withTheme: true})((props) => {
  const {
    classes,
    // theme,
    organizationId,
    projectId,
    documentId,
    onShowRevisions,
    onShowPrintSetup,
    onGetPrintStyles,
    forceEditorReloadForAllCollaboratorsTimestamp,
    onRequireDocXUpload,
    userName,
    userEmail,
    onLoadDocumentContent,
    onYjsUpdate,
    disabled,
    hostWidth,
    onGetFieldsPromise,
    // onApiError,
  } = props;

  const [ DialogDetails, setDialogDetails ] = useState({ Open: false });
  const [ FieldDialogOpen, setFieldDialogOpen ] = useState(false);
  const [ FieldDialogProperties, setFieldDialogProperties ] = useState({});
  const [ Fields, setFields ] = useState([]);
  const [ SelectedField, setSelectedField ] = useState(null);
  const showTextDialog = (title, label, defaultValue, confirmCallback, cancelCloseCallback) => {
    setDialogDetails({
      Open:true,
      Title:title,
      DialogWidth: "xs",
      RequireTextInput1: true,
      TextInput1Label: label,
      TextInput1DefaultValue: defaultValue,
      ConfirmLabel: "GO",
      ConfirmCallback: confirmCallback,
      CancelCallback: cancelCloseCallback,
      CloseCallback: cancelCloseCallback,
    });
  }

  const hideDialog = () => {
    setDialogDetails({ Open: false });
  }

  const handleFieldSelectionListFilter = useCallback(filter => {
    const getFilteredFieldsPromise = fields => {
      const filteredFields = fields.filter(f => 
        f.Type !== "FieldType_Image"
          && f.Name.toLowerCase().startsWith(filter.toLowerCase()))
        .map(f => {
          return {
            label:f.Name,
            value:f.ID,
          };
        });
      return filteredFields;
    }
    if (Fields && Fields.length) {
      return Promise.resolve(getFilteredFieldsPromise(Fields));
    } else {
      return onGetFieldsPromise()
        .then(fields => {
          setFields(fields);
          return getFilteredFieldsPromise(fields);
        });
    }
  }, [ Fields, onGetFieldsPromise ]);

  const handleSetSelectedFieldById = fieldId => {
    if (!fieldId) {
      return setSelectedField(null);
    }
    const fieldFinder = Fields.filter(f => f.ID === fieldId);
    if (fieldFinder.length) {
      setSelectedField(fieldFinder[0]);
    }
  }

  const handleSelectedFieldValueChange = selectedOption => {
    return handleSetSelectedFieldById(selectedOption.value);
  }
  
  const showFieldDialog = (show, attrs, confirmCallback, cancelCloseCallback) => {
    setFieldDialogProperties({
      confirmCallback,
      cancelCloseCallback,
    });
    setFieldDialogOpen(show);
    if (show) {
      handleSetSelectedFieldById(attrs && attrs.fieldId);
    }
  }

  const handleFieldDialogConfirm = () => {
    setFieldDialogOpen(false);
    if (FieldDialogProperties.confirmCallback) {
      FieldDialogProperties.confirmCallback(SelectedField);
    }
  }

  const handleFieldDialogCloseCancel = () => {
    showFieldDialog(false);
    if (FieldDialogProperties.cancelCloseCallback) {
      FieldDialogProperties.cancelCloseCallback(SelectedField);
    }
  }

  const fieldDialogDetails = {
    Open:FieldDialogOpen,
    Title:"Choose a field",
    DialogWidth: "sm",
    FullWidth: true,
    BodyContent: (
      <AsyncSelectControl
        autoFocus
        id="selectField"
        label="Field"
        hideEmpty
        fullWidth
        onGetOptionsFilterPromise={handleFieldSelectionListFilter} 
        value={SelectedField && {label:SelectedField.Name,value:SelectedField.ID}}
        onValueChange={handleSelectedFieldValueChange}
      />
    ),
    IsConfirmation: true,
    ConfirmLabel: "GO",
    ConfirmCallback: (SelectedField) ? handleFieldDialogConfirm : undefined,
    CancelCallback: handleFieldDialogCloseCancel,
    CloseCallback: handleFieldDialogCloseCancel,
  }

  const onRequestReload = () => {
    setDialogDetails({
      Open:true,
      Title:"Reload required",
      BodyText: "A collaborator has performed an action that requires you to reload.",
      DialogWidth: "xs",
      CloseLabel: "RELOAD",
      CloseCallback: () => window.location.reload(),
    });
  }

  const [ yDoc, /*setYDoc*/ ] = useState(new Y.Doc());
  const [ ready, setReady ] = useState(false);

  let yjsProvider;
  const getYjsProvider = yDoc_optional => {
    if (!yDoc_optional) {
      yDoc_optional = yDoc;
    }
    // console.log("get provider");
    yjsProvider = new WebrtcProvider(`n1de_${documentId}`, yDoc_optional,
      { maxConns: 50 + Math.floor(Math.random() * 15),
        password: `${organizationId}_${projectId}`,
        signaling: [
          // 'ws://localhost:4444',
          'wss://signaling.nucleus.one',
        ],
      },
    );
    yjsProvider.awareness.on("change", handleAwarenessChange);
    return yjsProvider;
  }

  const setYjsAwarenessField = useCallback((key, value) => {
    if (yjsProvider) {
      // console.log("setting awareness property");
      yjsProvider.awareness.setLocalStateField(key, value);
    }
  }, [ yjsProvider ]);

  useEffect(() => {
    if (forceEditorReloadForAllCollaboratorsTimestamp) {
      // console.log("forceEditorReloadForAllCollaboratorsTimestamp", forceEditorReloadForAllCollaboratorsTimestamp);
      setYjsAwarenessField("docDestroyAndRequestReload", forceEditorReloadForAllCollaboratorsTimestamp);
    }
  }, [ forceEditorReloadForAllCollaboratorsTimestamp, setYjsAwarenessField ]);

  // Using state variables inside handleAwarenessChange has no effect for some reason
  const [ Collaborators, setCollaborators ] = useState([]);
  const onSetCollaborators = c => {
    // console.log("onSetCollaborators", c);
    setCollaborators(c);
  }
  const loadTimestamp = new Date();
  let reloadTimestamp;
  const handleAwarenessChange = ({ added: addedIds, updated: updatedIds, removed: removedIds }) => {
    // console.log(loadTimestamp);
    // console.log("handleAwarenessChange current-clientId", yjsProvider.awareness.clientID);

    const states = yjsProvider.awareness.getStates();

    const setCollaborators = (ids, remove) => {
       // console.log("setCollaborators", ids);
      if (!ids || !ids.length) {
        return;
      }
      ids.forEach(id => {
        if (remove) {
          // console.log("removing", id);
          onSetCollaborators(Collaborators.filter(c => c.id !== id));
          return;
        }
        // console.log(id);
        if (states.has(id)) {
          if (yjsProvider.awareness.clientID === id) {
            return;
          }
          const s = states.get(id);
          if (s.user) {
            const name = s.user.name || "Unknown user";
            const existingFinder = Collaborators.filter(c => c.id === id);
            if (!existingFinder.length) {
              Collaborators.push({id, name, email: s.user.email});
            }
            onSetCollaborators(Collaborators);
          }
        }
      });
    }

    const handleEvent = ids => {
      // console.log("handleEvent", ids);
      if (!ids || !ids.length) {
        return;
      }
      ids.forEach(i => {
        // console.log(i);
        if (states.has(i)) {
          const s = states.get(i);
          // console.log(s);
          // DOC DESTROY
          if (s.hasOwnProperty("docDestroyAndRequestReload")) {
            // Ignore calls from this client
            if (yjsProvider.awareness.clientID === i) {
              return;
            }
            const docDestroyAndRequestReload = new Date(s["docDestroyAndRequestReload"]);
            // console.log("Doc Destroy request", docDestroyAndRequestReload, "load", loadTimestamp);
            if (docDestroyAndRequestReload > loadTimestamp) {
              // console.log("destroying doc and reloading from awareness", docDestroyAndRequestReload, addedIds, updatedIds, removedIds);
              setReady(false);
              yjsProvider.destroy();
              yDoc.destroy();
              onRequestReload();
            }
          }
          // RELOAD
          if (s.hasOwnProperty("reload")) {
            // Ignore calls from this client
            if (yjsProvider.awareness.clientID === i) {
              return;
            }
            const reload = new Date(s["reload"]);
            // console.log("Reload request", reload, "load", loadTimestamp, "reloadTimestamp", reloadTimestamp);
            if (reload > loadTimestamp && reload !== reloadTimestamp) {
              reloadTimestamp = reload;
              // console.log("reloading from awareness", reload, addedIds, updatedIds, removedIds);
              window.location.reload();
            }
          }
        }
      });
    }

    if (addedIds && addedIds.length) {
      // console.log("addedIds", addedIds, states);
      handleEvent(addedIds);
      setCollaborators(addedIds);
    }
    if (updatedIds && updatedIds.length) {
      // console.log("updatedIds", updatedIds, states);
      handleEvent(updatedIds);
      setCollaborators(updatedIds);
    }
    if (removedIds && removedIds.length) {
      // console.log("removedIds", removedIds, states);
      setCollaborators(removedIds, true);
    }
  }

  useEffect(() => {
    if (yjsProvider) {
      if (userName || userEmail) {
        // console.log("setting awareness");
        yjsProvider.awareness.setLocalStateField('user', 
          {
            color: "#788100",
            name: (userName) ? userName : (userEmail) ? userEmail : undefined,
            email: userEmail,
          }
        );
      }
    }
  });

  // This is critical to ensuring collaboration continues to work when the editor is reloaded
  useEffect(() => {
    return () => {
      if (yjsProvider) {
        // console.log("destroying yjsProvider");
        yjsProvider.destroy();
      }
      if (yDoc) {
        // console.log("destroying yDoc");
        yDoc.destroy();
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // This overrides the native PAGEUP/PAGEDOWN behavior of the editor because a Chrome bug causes
  // the side drawers to come into view incorrectly.
  useEffect(() => {
    window.addEventListener('keydown', e => {
      if (e.key === 'PageUp' || e.key === 'PageDown') {
        if (e.target.contentEditable && e.target.classList.contains("remirror-editor")) {
          const scrollElement = e.target.parentElement;          
          const scrollSize = scrollElement.clientHeight / 1.1;
          const scrollPosition =
            (e.key === 'PageUp')
              ? Math.max(0, scrollElement.scrollTop-scrollSize)
              : Math.min(scrollElement.scrollHeight, scrollElement.scrollTop+scrollSize);
          e.preventDefault();
          scrollElement.scrollTop = scrollPosition;
        }
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleRequireDocXUpload = () => {
    // console.log("handleRequireDocXUpload", yjsProvider);
    if (yjsProvider) {
      yjsProvider.destroy();
    }
    onRequireDocXUpload();
  }

  const [ createRevisionTimestamp, setCreateRevisionTimestamp ] = useState(null);
  const handleCreateRevision = () => {
    setCreateRevisionTimestamp(new Date());
  }

  const progressIndicator = (!ready)
    ? ( <ProgressIndicator showImmediately /> )
    : null;

  if (!onLoadDocumentContent || !onYjsUpdate) {
    return null;
  }

  const { manager, state, /*setState*/ } = useRemirror(GetRemirrorParameters(getYjsProvider));
  const editor = (
    <div className={classes.editorContainer}>
      <div className={classes.editor}
        style={{
          maxWidth: (!IsMobile() && hostWidth) ? `${Math.floor(hostWidth)}px` : undefined,
        }}
      >
        {/* the className is used to define css variables necessary for the editor */}
        <div className='remirror-theme' style={{height:"100%", overflow:(IsMobile()) ? undefined : "hidden"}}>
          <Remirror
            manager={manager}
            initialContent={state}
            hooks={getHooks(showTextDialog, hideDialog)}
            editable={!disabled}
          >
            <PersistenceComponent
              {...props}
              yDoc={yDoc}
              yjsProvider={yjsProvider}
              onSetReady={setReady}
              onSetYjsAwarenessField={setYjsAwarenessField}
              createRevisionTimestamp={createRevisionTimestamp}
            />
            {/* Functions within the ToolMenu component require that it lives within the <Remirror /> component. */}
            <ToolMenu {...props}
              showTextDialog={showTextDialog}
              hideDialog={hideDialog}
              showFieldDialog={showFieldDialog}
              showRevisions={onShowRevisions}
              showPrintSetup={onShowPrintSetup}
              // onReplaceStateWithDoc={handleReplaceStateWithDoc}
              onRequireDocXUpload={handleRequireDocXUpload}
              onCreateRevision={handleCreateRevision}
              editorDisabled={disabled}
              collaborators={Collaborators}
            />
            {/*<PageDividersComponent />*/}
            <div className={classes.editorComponentContainer}>
              <EditorComponent />
            </div>
          </Remirror>
        </div>
      </div>
    </div>
  );

  return (
    <div className={classes.coreRoot}>
      <style name="printStyles">{onGetPrintStyles()}</style>
      <MultiUseDialog Details={DialogDetails} />
      <MultiUseDialog Details={fieldDialogDetails} />
      {editor}
      {progressIndicator}
    </div>
  );
})

Core.propTypes = {
  organizationId: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  documentId: PropTypes.string.isRequired,
  onLoadDocumentContent: PropTypes.func.isRequired,
  onYjsUpdate: PropTypes.func.isRequired,
  onHtmlUpdate: PropTypes.func.isRequired,
  onRemirrorStateUpdate: PropTypes.func.isRequired,
  onEditorLoaded: PropTypes.func.isRequired,
  onSetPrintContent: PropTypes.func.isRequired,
  forceEditorReloadForAllCollaboratorsTimestamp: PropTypes.object,
  onShowRevisions: PropTypes.func.isRequired,
  onShowPrintSetup: PropTypes.func.isRequired,
  onSetOtherAppBarContent: PropTypes.func.isRequired,
  onGetPrintStyles: PropTypes.func.isRequired,
  onRequireDocXUpload: PropTypes.func.isRequired,
  initialRemirrorHtml: PropTypes.string,
  onClearInitialRemirrorHtml: PropTypes.func.isRequired,
  parentScrollTop: PropTypes.number,
  label: PropTypes.string,
  userName: PropTypes.string,
  userEmail: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  hostWidth: PropTypes.number,
  onApiError: PropTypes.func.isRequired,
};

const DocumentEditor = props => {
  const {
    classes,
    theme,
  } = props;

  const [ ShowProgressIndicatorImmediately, setShowProgressIndicatorImmediately ] = useState(false);
  const [ RequireDocXUpload, setRequireDocXUpload ] = useState(false);
  const [ InitialRemirrorHtmlForCore, setInitialRemirrorHtmlForCore ] = useState();

  const handleRequireDocXUpload = value_optional => {
    setInitialRemirrorHtmlForCore(null);
    if (typeof value_optional === "boolean") {
      setRequireDocXUpload(value_optional);
    } else {
      setRequireDocXUpload(true);
    }
  }

  const handleDocxFileDrop = files => {
    setShowProgressIndicatorImmediately(true);
    convertToHtml({
      arrayBuffer: files[0],
    })
      .then(result => {
        // console.log(result.value);
        // console.log("setting InitialRemirrorHtmlForCore");
        setInitialRemirrorHtmlForCore(result.value);
      })
      .finally(() => {
        setShowProgressIndicatorImmediately(false);
        setRequireDocXUpload(false);
      });
  }

  const docXImporter = (RequireDocXUpload) ? (
    <div className={classes.docXImporter}>
      <Dropzone
        key="uploadDropZone"
        onDrop={handleDocxFileDrop}
        noClick
        noKeyboard
        multiple={false}
        accept=".docx"
      >
        {({getRootProps, getInputProps, open}) => {
          return (
            <div 
              {...getRootProps()}
              className={classes.docxFileDropZone}
              // style={{
              //   marginLeft:11,
              // }}
            >
              <input {...getInputProps()} />
              
              <Typography variant="h5">
                Drag and drop DOCX
              </Typography>
              <Typography variant="body1" style={{marginTop:theme.spacing(3)}}>
                Or
                <Button variant="contained"
                  style={{marginTop:-4,marginLeft:8}}
                  onClick={open}>
                  SELECT FILE
                </Button>
              </Typography>
              <Typography variant="body1" style={{marginTop:theme.spacing(3)}}>
                Or
                <Button variant="contained"
                  style={{marginTop:-4,marginLeft:8}}
                  onClick={() => handleRequireDocXUpload(false)}>
                  BACK TO EDITOR
                </Button>
              </Typography>

            </div>
          );
        }}
      </Dropzone>
    </div>
  ) : null;

  const progressIndicator = (ShowProgressIndicatorImmediately)
    ? ( <ProgressIndicator showImmediately={ShowProgressIndicatorImmediately} /> )
    : null;

  const editorCore = (!RequireDocXUpload)
    ? (
      <Core {...props}
        onRequireDocXUpload={handleRequireDocXUpload}
        initialRemirrorHtml={InitialRemirrorHtmlForCore}
        // This is necessary to ensure the html is not imported more than once in certain contexts
        onClearInitialRemirrorHtml={() => setTimeout(() => setInitialRemirrorHtmlForCore(null), 1)}
      />
    ) : null;

  return (
    <div className={classes.editorRoot}>
      {progressIndicator}
      {editorCore}
      {docXImporter}
    </div>
  );
}

DocumentEditor.propTypes = {
  organizationId: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  documentId: PropTypes.string.isRequired,
  onLoadDocumentContent: PropTypes.func.isRequired,
  forceEditorReloadForAllCollaboratorsTimestamp: PropTypes.object,
  onYjsUpdate: PropTypes.func.isRequired,
  onHtmlUpdate: PropTypes.func.isRequired,
  onRemirrorStateUpdate: PropTypes.func.isRequired,
  onEditorLoaded: PropTypes.func.isRequired,
  onSetPrintContent: PropTypes.func.isRequired,
  onSetOtherAppBarContent: PropTypes.func.isRequired,
  onShowRevisions: PropTypes.func.isRequired,
  onShowPrintSetup: PropTypes.func.isRequired,
  onGetPrintStyles: PropTypes.func.isRequired,
  onGetFieldsPromise: PropTypes.func.isRequired,
  parentScrollTop: PropTypes.number,
  label: PropTypes.string,
  userName: PropTypes.string,
  userEmail: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  hostWidth: PropTypes.number,
  onApiError: PropTypes.func.isRequired,
};

export default withStyles(styles, {withTheme: true})(DocumentEditor);